"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_VALIDATE_POST_MESSAGE = exports.ERROR_SEND_BOOKING_DATA = exports.ERROR_SEND_REFERRAL_DATA = exports.ERROR_REQUEST_PATIENT = exports.DONE_INVOKE_VALIDATE_POST_MESSAGE = exports.DONE_INVOKE_SEND_BOOKING_DATA = exports.DONE_INVOKE_SEND_REFERRAL_DATA = exports.DONE_INVOKE_REQUEST_PATIENT = exports.UNKNOWN_ORIGIN = exports.FAIL_MAX_RETRIES = exports.FAIL_NO_RETRY = exports.RETRY = exports.DISMISS_ERROR = exports.SET_CONFIRMATION_MESSAGE = exports.PATIENT_RECEIVED = exports.SEND_BOOKING_DATA = exports.SEND_REFERRAL_DATA = exports.REMOVE_REFERRAL = exports.ADD_REFERRAL = void 0;
exports.ADD_REFERRAL = '@events/ADD_REFERRAL';
exports.REMOVE_REFERRAL = '@events/REMOVE_REFERRAL';
exports.SEND_REFERRAL_DATA = '@events/SEND_REFERRAL_DATA';
exports.SEND_BOOKING_DATA = '@events/SEND_BOOKING_DATA';
exports.PATIENT_RECEIVED = '@events/PATIENT_RECEIVED';
exports.SET_CONFIRMATION_MESSAGE = '@events/SET_CONFIRMATION_MESSAGE';
exports.DISMISS_ERROR = '@events/DISMISS_ERROR';
exports.RETRY = '@events/RETRY';
exports.FAIL_NO_RETRY = '@events/FAIL_NO_RETRY';
exports.FAIL_MAX_RETRIES = '@events/FAIL_MAX_RETRIES';
exports.UNKNOWN_ORIGIN = '@events/UNKNOWN_ORIGIN';
// Service-defined events
exports.DONE_INVOKE_REQUEST_PATIENT = 'done.invoke.requestPatient';
exports.DONE_INVOKE_SEND_REFERRAL_DATA = 'done.invoke.sendReferralData';
exports.DONE_INVOKE_SEND_BOOKING_DATA = 'done.invoke.sendBookingData';
exports.DONE_INVOKE_VALIDATE_POST_MESSAGE = 'done.invoke.validatePostMessage';
exports.ERROR_REQUEST_PATIENT = 'error.platform.requestPatient';
exports.ERROR_SEND_REFERRAL_DATA = 'error.platform.sendReferralData';
exports.ERROR_SEND_BOOKING_DATA = 'error.platform.sendBookingData';
exports.ERROR_VALIDATE_POST_MESSAGE = 'error.platform.validatePostMessage';
//# sourceMappingURL=events.js.map